// 教务管理api
import request from "./api";
// 获取教师列表
export const queryNameOrMobilePage = (params, opts) => request("/api-teachingaffair/teachingAffair/queryNameOrMobilePage", params, { ...opts, method: "post", });
// 添加教师
export const addTeacher = (params, opts) => request("/api-teachingaffair/teachingAffair/addTeacher", params, { ...opts, method: "post", });
// 修改教师
export const updateTeacher = (params, opts) => request("/api-teachingaffair/teachingAffair/updateTeacher", params, { ...opts, method: "post", });
// 删除用户（教师、学生）
export const deleteUser = (params, opts) => request("/api-teachingaffair/teachingAffair/deleteUser", params, { ...opts, method: "post", });
// 获取角色
export const getRole = (params, opts) => request("/api-user/sys/role/user/role", params, opts);
// 获取科目
export const getSubjectList = (id, params, opts) => request("/api-resource/cjdd-resources/professionSubjects/third/"+id, params, opts);
// 导入用户（教师、学生）
export const importUser = (params, opts) => request("/api-teachingaffair/teachingAffair/excel/upload", params, { ...opts, method: "post", });
// 重置密码
export const resetPassword = (params, opts) => request("/api-user/sys/user/adminPassword", params, { ...opts, method: "put", });
// 提交审核
export const submiteAudit = (params, opts) => request("/api-teachingaffair/teachingAffair/update/teacher/audit/list", params, { ...opts, method: "put", });
// 获取教学班
export const getTeachingClass = (params, opts) => request("/api-teachingaffair/teachingAffair/teachingClass", params, opts);
export const newgetTeachingClass = (params, opts) => request("/api-teachingaffair/teachingClass/selectClassNoPage", params, { ...opts, method: "post", });
// 添加学生
export const addStudent = (params, opts) => request("/api-teachingaffair/teachingAffair/addStudent", params, { ...opts, method: "post", });
// 修改学生
export const updateStudent = (params, opts) => request("/api-teachingaffair/teachingAffair/updateStudent", params, { ...opts, method: "post", });
// 根据id查科目
export const querySubjectList = (id, params, opts) => request("/api-resource/cjdd-resources/professionSubjects/"+id, params, opts);
// 添加科目
export const addSubject = (params, opts) => request("/api-resource/cjdd-resources/subject", params, { ...opts, method: "post", });
// 查询授权列表
export const getAuthList = (params, opts) => request("/api-course/authCourse/auth/list", params, { ...opts, method: "post", });
// 查询课程列表
export const queryCourseList = (params, opts) => request("/api-course/authCourse/queryCourseList", params, { ...opts, method: "post", });
// 查询院校列表
export const queryDeptList = (params, opts) => request("/api-user/sys/dept/infos", params, { ...opts, method: "post", });
// 删除授权
export const deleteAuth = (params, opts) => request("/api-course/authCourse/delete", params, { ...opts, method: "post", });
// 修改授权
export const updateAuth = (params, opts) => request("/api-course/authCourse/updateAuth", params, { ...opts, method: "post", });
// 添加授权
export const addAuth = (params, opts) => request("/api-course/authCourse/addAuth", params, { ...opts, method: "post", });
// 根据机构id查询信息
export const getDeptInfo = (id, params, opts) => request("/api-user/sys/dept/query/dept/"+id, params, opts);
// 修改机构信息
export const updateDeptLogo = (params, opts) => request("/api-user/sys/dept/update", params, { ...opts, method: "post", });
// 获取开课计划信息
export const getPlanInfo = (params, opts) => request("/api-teachingaffair/lessonPlan", params, opts);
// 初始化教学班
export const initTeachingClass = (schoolId, userId, params, opts) => request(`/api-teachingaffair/teachingClass/${schoolId}/${userId}`, params, opts);
// 开课计划列表
export const getCoursePlanList = (schoolId, planId, params, opts) => request(`/api-teachingaffair/lesson/${schoolId}/${planId}`, params, opts);
// 删除开课计划
export const deletePlan = (schoolId, classId, planId, params, opts) => request(`/api-teachingaffair/deleteLesson/${schoolId}/${classId}/${planId}`, params, { ...opts, method: "delete", });
// 导入开课计划
export const importPlan = (schoolId, classId, planId, params, opts) => request(`/api-teachingaffair/importLesson/${schoolId}/${classId}/${planId}`, params, { ...opts, method: "post", });
// 查看开课计划
export const previewPlan = (schoolId, classId, planId, params, opts) => request(`/api-teachingaffair/lessonRecord/${schoolId}/${classId}/${planId}`, params, opts);
// 考试报名-学生管理列表
export const queryExamStudent = (params, opts) => request("/api-teachingaffair/queryExamStudent", params, { ...opts, method: "post", });
// 考试报名-添加申请
export const enlistExamStudent = (params, opts) => request("/api-teachingaffair/enlistExamStudent", params, { ...opts, method: "post", });
// 考试报名-已报名的名单
export const joinExamStudent = (params, opts) => request("/api-teachingaffair/joinExamStudent", params, { ...opts, method: "post", });
// 考试报名-取消报名
export const cancelExam = (params, opts) => request("/api-teachingaffair/joinExamStudent", params, { ...opts, method: "delete", });
// 获取教学计划列表
export const getTrainPlan = (params, opts) => request("/api-teachingaffair/teacher/get/trainPlan", params, { ...opts, method: "post", });
// 开课信息列表
export const getTrainPlanRecord = (trainPlanId, deptId, params, opts) => request(`/api-teachingaffair/getTrainPlanRecord/${trainPlanId}/${deptId}`, params, opts);
// 开课信息修改保存
export const saveTrainPlan = (params, opts) => request("/api-teachingaffair/save/trainPlanRecord", params, { ...opts, method: "post", });
// 教务端保存教学计划老师信息
export const updateTrainPlanRecordTeacher = (params, opts) => request("/api-teachingaffair/update/trainPlanRecordTeacher", params, { ...opts, method: "post", });
export const saveTrainPlanRecordTeacher = (params, opts) => request("/api-teachingaffair/save/trainPlanRecordTeacher", params, { ...opts, method: "post", });
// 开课信息删除
export const deleteTrainPlan = (id, params, opts) => request(`/api-teachingaffair/delete/trainPlanRecordTeacher/${id}`, params, { ...opts, method: "delete", });
// 获取开课信息的Count
export const getTrainPlanRecordCount = (id, params, opts) => request(`/api-teachingaffair/collect/trainPlanRecordTeacher/by/trainPlanRecord/${id}`, params, opts);


// 组织管理-角色权限-根据机构id获取角色权限树
export const getMenuList = (deptId, params, opts) => request(`/api-user/sys/menu/findAllByDeptId/${deptId}`, params, opts);
// 组织管理-角色权限-添加角色
export const addRole = (params, opts) => request("/api-user/sys/role/save", params, { ...opts, method: "post", });
// 组织管理-角色权限-修改角色
export const updateRole = (params, opts) => request("/api-user/sys/role/update", params, { ...opts, method: "post", });
// 组织管理-角色权限-根据角色id获取角色树
export const getRoleTreeList = (id, params, opts) => request("/api-user/sys/role/infoNoAuth/"+id, params, { ...opts, method: "post", });
// 组织管理-角色权限-删除角色
export const deleteRole = (params, opts) => request("/api-user/sys/role/delete", params, { ...opts, method: "post", });
// 获取角色列表
export const getRoleList = (params, opts) => request("/api-user/sys/role/listNoAuth", params, { ...opts, method: "post", });

// 组织管理-管理员-查询角色列表
export const queryRole = (params, opts) => request("/api-user/sys/role/queryRole", params, { ...opts, method: "post", });
// 组织管理-管理员-获取机构下一级组织
export const queryStructFirstLevel = (params, opts) => request(`/api-user/sys/struct/queryStructFirstLevel/`+params, {}, opts);
// 组织管理-管理员-管理员列表
export const getAdminList = (params, opts) => request("/api-teachingaffair/teachingAffair/queryAdminList", params, { ...opts, method: "post", });
// 组织管理-管理员-添加管理员
export const addAdmin = (params, opts) => request("/api-teachingaffair/teachingAffair/addAdmin", params, { ...opts, method: "post", });
// 组织管理-管理员-修改管理员
export const updateAdmin = (params, opts) => request("/api-teachingaffair/teachingAffair/updateAdmin", params, { ...opts, method: "post", });
// 组织管理-管理员-删除管理员
export const deleteAdmin = (params, opts) => request("/api-teachingaffair/teachingAffair/deleteAdmin", params, { ...opts, method: "post", });


/**
 * 教务中心 - 组织结构
*/
//查询列表
export const queryAll = (params, opts) => request('/api-teachingaffair/teachingAffair/struct/queryAll', params, { ...opts, method: 'post' });
//获取产品分类
export const queryProdClassByDeptId = (params, opts) => request('/api-user/sys/prod/queryProdClassByDeptId', params, { ...opts, method: 'post' });
//获取产品分类下的产品
export const queryProdByDeptId = (params, opts) => request('/api-user/sys/prod/queryProdByDeptId', params, { ...opts, method: 'post' });
//添加组织
export const saveStruct = (params, opts) => request('/api-teachingaffair/teachingAffair/struct/saveStruct', params, { ...opts, method: 'post' });
//修改组织
export const eidtStruct = (params, opts) => request('/api-teachingaffair/teachingAffair/struct/eidtStruct', params, { ...opts, method: 'post' });
//删除组织
export const deleteStruct = (params, opts) => request('/api-teachingaffair/teachingAffair/struct/deleteStruct/'+params, {}, { ...opts, method: 'delete' });

//查询二级组织
export const queryStructSecondLevel = (params, opts) => request('/api-user/sys/struct/queryStructSecondLevel/'+params, params, { ...opts, method: 'get' });
//添加班级
export const addClass = (params, opts) => request('/api-teachingaffair/teachingClass/addClass', params, { ...opts, method: 'post' });
//编辑班级
export const updateClass = (params, opts) => request('/api-teachingaffair/teachingClass/updateClass', params, { ...opts, method: 'post' });
//查询班级
export const selectClass = (params, opts) => request('/api-teachingaffair/teachingClass/selectClass', params, { ...opts, method: 'post' });
//删除班级
export const deleteClass = (params, opts) => request('/api-teachingaffair/teachingClass/deleteClass', params, { ...opts, method: 'post' });
//根据班级查询学生
export const queryStudentByClassId = (params, opts) => request('/api-teachingaffair/teachingAffair/queryStudentByClassId', params, { ...opts, method: 'post' });
// 新导入用户（教师、学生）
export const importInClass = (params, opts) => request("/api-teachingaffair/teachingAffair/excel/upload/inClass", params, { ...opts, method: "post", });
// 添加学生
export const newAddStudent = (params, opts) => request("/api-teachingaffair/teachingClass/addStudent", params, { ...opts, method: "post", });
// 添加学生
export const queryUserStruct = (params, opts) => request("/api-user/sys/struct/queryUserStruct", params, { ...opts, method: "get", });






// WEBPACK FOOTER //
// ./src/api/educationalApi.js